export default __webpack_public_path__ + "images/a858b8dcd9ee0b116b1b9665a370568b-bg-02.jpg";